import React from 'react';

import { Notice } from './styles';

export const IDP_MANAGED_NOTE_TESTID = 'idp-managed-note';

/** Shown once on a user record where the identity provider owns anything. */
export const IdpManagedNote: React.FunctionComponent = () => (
  <Notice data-testid={IDP_MANAGED_NOTE_TESTID}>
    Some of these fields come from your identity provider and can’t be edited here.
  </Notice>
);

export default IdpManagedNote;
